<template>
  <main class="mypage-redesign">
    <!-- 메인 콘텐츠 영역 -->
    <div class="mypage-container">
      <!-- MypageSidebar 컴포넌트 -->
      <MypageSidebar />

      <!-- 메인 콘텐츠 -->
      <div class="main-content">
        <!-- 콘텐츠 상세 섹션 -->
        <section v-if="Object.keys(myContents).length > 0" class="content-detail-section">
          <!-- 콘텐츠 정보 카드 -->
          <div class="content-hero">
            <div class="content-thumbnail">
              <img v-if="myContents.thumbnailLink" :src="'https://eduwind-api.nodeblack.net/' + myContents.thumbnailLink" :alt="myContents.orderContentTitle" />
              <img v-else :src="require('@/assets/img/null_img.jpg')" :alt="myContents.orderContentTitle" />
            </div>
            <div class="content-header">
              <h1 class="content-title">{{ myContents.orderContentTitle }}</h1>
              <div class="content-expiration">
                <div v-if="new Date(myContents.downloadExpiration) < base" class="expiration-unlimited">다운로드 기한: 무제한</div>
                <div v-else :class="{ expired: isExpired(myContents.downloadExpiration) }">
                  <p class="expiration-label">다운로드 기한</p>
                  <p class="expiration-date">
                    {{ formDownloadDate(myContents.downloadExpiration) }} 까지
                    <span v-if="isExpired(myContents.downloadExpiration)" class="expired-badge">기한만료</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- 다운로드/영상 재생 섹션 -->
          <div v-if="myContents.orderContentStatus == 'DOWNLOAD_DOING' || myContents.orderContentStatus == 'CREATE_DONE'" class="content-actions-section">
            <h2 class="section-title">콘텐츠</h2>

            <!-- FILE/IMAGE/MUSIC 타입 -->
            <div v-if="myContents.contentType == 'FILE' || myContents.contentType == 'MUSIC' || myContents.contentType == 'IMAGE'" class="download-section">
              <button v-if="myContents.orderDownloadInfoList && myContents.orderDownloadInfoList.length > 1" class="download-all-button" @click="downloadZIPContent">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.46154 17H2.23077C1.90435 17 1.5913 16.8703 1.36048 16.6395C1.12967 16.4087 1 16.0956 1 15.7692V5.92303H17V15.7692C17 16.0956 16.8703 16.4087 16.6395 16.6395C16.4087 16.8703 16.0957 17 15.7692 17H14.5385"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 1V5.92308M14.28 1.61538C14.1747 1.43291 14.0244 1.2805 13.8434 1.17275C13.6624 1.06501 13.4567 1.00552 13.2462 1H4.75385C4.54326 1.00552 4.33762 1.06501 4.1566 1.17275C3.97559 1.2805 3.82526 1.43291 3.72 1.61538L1 5.92308H17L14.28 1.61538Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path d="M6 13.0833L9 16M9 16L12 13.0833M9 16V9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                모두 다운로드
              </button>

              <div class="download-list">
                <button v-for="(content, idx) in myContents.orderDownloadInfoList" :key="content.orderDownloadId" class="download-item" @click="downloadContent(content.orderDownloadId)">
                  <span class="download-number">{{ idx + 1 }}.</span>
                  <span class="download-name">{{ content.orderDownloadName }}</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18 12.6667V16.2222C18 16.6937 17.8127 17.1459 17.4793 17.4793C17.1459 17.8127 16.6937 18 16.2222 18H3.77778C3.30628 18 2.8541 17.8127 2.5207 17.4793C2.1873 17.1459 2 16.6937 2 16.2222V12.6667M5.55556 8.22222L10 12.6667M10 12.6667L14.4444 8.22222M10 12.6667V2"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <!-- VIDEO 타입 -->
            <div v-else-if="myContents.contentType == 'VIDEO'" class="video-section">
              <div v-for="vid in myContents.orderVideoInfoList" :key="vid.orderVideoId" class="video-item">
                <h3 class="video-title">{{ vid.orderVideoName }}</h3>
                <div class="video-actions">
                  <button @click.prevent="vid.linkNormal ? openVideoModal(vid.linkNormal) : null" class="video-button primary" :class="{ disabled: !vid.linkNormal }" :disabled="!vid.linkNormal">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.6667 16.6667H2.08333V2.08333H16.6667M16.6667 0H2.08333C1.5308 0 1.00089 0.219493 0.610194 0.610194C0.219493 1.00089 0 1.5308 0 2.08333V16.6667C0 17.2192 0.219493 17.7491 0.610194 18.1398C1.00089 18.5305 1.5308 18.75 2.08333 18.75H16.6667C17.2192 18.75 17.7491 18.5305 18.1398 18.1398C18.5305 17.7491 18.75 17.2192 18.75 16.6667V2.08333C18.75 1.5308 18.5305 1.00089 18.1398 0.610194C17.7491 0.219493 17.2192 0 16.6667 0ZM7.29167 5.20833V13.5417L12.5 9.375L7.29167 5.20833Z"
                        fill="currentColor"
                      />
                    </svg>
                    일반화질 보기
                  </button>

                  <button @click.prevent="vid.linkHigh ? openVideoModal(vid.linkHigh) : null" class="video-button secondary" :class="{ disabled: !vid.linkHigh }" :disabled="!vid.linkHigh">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M16.7917 0.125H2.20833C1.05208 0.125 0.125 1.05208 0.125 2.20833V16.7917C0.125 17.9375 1.0625 18.875 2.20833 18.875H16.7917C17.9375 18.875 18.875 17.9375 18.875 16.7917V2.20833C18.875 1.6558 18.6555 1.12589 18.2648 0.735194C17.8741 0.344493 17.3442 0.125 16.7917 0.125ZM7.41667 13.6667V5.33333L12.625 9.5"
                        fill="currentColor"
                      />
                    </svg>
                    고화질 보기
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 이용 불가 상태 -->
          <div v-else class="unavailable-section">
            <svg width="56" height="49" viewBox="0 0 56 49" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M27.8771 2.72916L2.66872 46.2708H53.0854L27.8771 2.72916Z" stroke="#9ca3af" stroke-width="4.58333" stroke-linejoin="round" />
              <path d="M27.877 37.1041V38.25M27.877 18.7708L27.8862 30.2291" stroke="#9ca3af" stroke-width="4.58333" stroke-linecap="round" />
            </svg>
            <h3>이용이 불가합니다.</h3>
          </div>

          <!-- 이용안내 섹션 -->
          <div class="usage-guide-section">
            <h2 class="section-title">이용안내</h2>
            <div class="usage-guide-content">
              <div class="guide-block">
                <h4>사용허가정보</h4>
                <p>- 설교콘텐츠의 재편집은 가능하나 제3자에게 배포, 판매, 양도, 대여할 수 없습니다.</p>
                <p>- 구매한 콘텐츠 원본은 SNS포함 모든 온라인에 배포할 수 없습니다.</p>
                <p>- 영상 콘텐츠로의 편집 후 유투브등의 영상채널에 배포시 추가 라이센스 획득 후 사용하셔야 합니다.</p>
                <p>- 웹 및 온라인 배포, 상업적 용도, 인쇄물 제작시에는 별도 확장 라이센스 획득이 필요합니다.</p>
              </div>

              <div class="guide-block">
                <h4>환불안내</h4>
                <p>- 콘텐츠 다운로드시, 원하는 콘텐츠 인지 꼭 한번 더 확인을 부탁드립니다.</p>
                <p>- 결제 및 다운로드 후 1개월 이내에는 횟수 제한 없이 재다운로드가 가능합니다.</p>
                <p>- 결제 및 다운로드 후 1개월 이내에 콘텐츠 자체의 오류나 이상등이 발견되는 경우 환불 조치가 가능하며, 환불대신 새파일을 받기 요청하시면 새파일 다운로드 가능합니다.</p>
                <p>콘텐츠제작관련과 기타 콘텐츠에 대한 문의사항은 문의게시판에 남겨주시면 답변 드리겠습니다.</p>
              </div>
            </div>
          </div>

          <!-- 목록으로 버튼 -->
          <router-link to="/mypage/contentsBox" class="back-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
              <path d="M9.5 1.5L1.5 9.5L9.5 17.5" stroke="currentColor" stroke-width="2" />
              <path d="M19.5 9.5H1.5" stroke="currentColor" stroke-width="2" />
            </svg>
            목록으로
          </router-link>
        </section>
      </div>
    </div>

    <!-- 영상 모달 -->
    <div v-if="isDetailModalOpen" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black/60" @click="closeDetailModal"></div>
      <div class="relative z-10 w-full max-w-[70.5rem] mx-4 bg-white rounded-2xl shadow-xl overflow-hidden">
        <div class="flex items-center justify-end border-b border-neutral-200 md:p-4 p-2">
          <button type="button" class="text-neutral-400 hover:text-neutral-700" @click="closeDetailModal">
            <span class="sr-only">닫기</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.062 4.062a.875.875 0 0 1 1.237 0L10 8.763l4.701-4.701a.875.875 0 1 1 1.237 1.237L11.237 10l4.701 4.701a.875.875 0 0 1-1.237 1.237L10 11.237l-4.701 4.701a.875.875 0 1 1-1.237-1.237L8.763 10 4.062 5.299a.875.875 0 0 1 0-1.237Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div class="max-h-[70vh] overflow-y-auto">
          <div v-if="selectedContentDetail" class="space-y-6">
            <section v-for="(section, idx) in selectedContentDetail" :key="idx">
              <template v-if="section.videoLinkNormal">
                <iframe
                  v-if="getVideoInfo(section.videoLinkNormal).type === 'youtube'"
                  :src="getVideoInfo(section.videoLinkNormal).src"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                  style="width: 100%; height: auto; aspect-ratio: 16 / 9"
                ></iframe>

                <div v-else-if="getVideoInfo(section.videoLinkNormal).type === 'vimeo'" style="width: 100%; height: auto; aspect-ratio: 16 / 9">
                  <iframe
                    :src="getVideoInfo(section.videoLinkNormal).src"
                    frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    style="width: 100%; height: 100%"
                    allowfullscreen
                  ></iframe>
                </div>

                <iframe v-else :src="section.videoLinkNormal" allowfullscreen style="width: 100%; height: auto; aspect-ratio: 16 / 9"></iframe>
              </template>
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import axios from "axios";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import MypageSidebar from "@/components/MypageSidebar.vue";

const route = useRoute();

const orderContentId = route.params.ocid;
const myContents = ref({});

// 모달 관련 상태
const isDetailModalOpen = ref(false);
const selectedContentDetail = ref([]);

// 비메오 API 스크립트 로드
onMounted(async () => {
  await getOrderContentDetail();

  if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
    const script = document.createElement("script");
    script.src = "https://player.vimeo.com/api/player.js";
    document.head.appendChild(script);
  }
});

// 모달 열기
const openVideoModal = (url) => {
  if (!url) return;
  selectedContentDetail.value = [{ videoLinkNormal: url }];
  isDetailModalOpen.value = true;
};

// 모달 닫기
const closeDetailModal = () => {
  isDetailModalOpen.value = false;
  selectedContentDetail.value = [];
};

// 영상 URL 파싱 및 타입 확인
const getVideoInfo = (url) => {
  if (!url) return { type: null };

  const trimmed = url.trim();

  // 비메오 체크
  const vimeoMatch = trimmed.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
  if (vimeoMatch && vimeoMatch[1]) {
    return {
      type: "vimeo",
      id: vimeoMatch[1],
      src: `https://player.vimeo.com/video/${vimeoMatch[1]}`,
    };
  }

  // 유튜브 체크
  const ytMatch = trimmed.match(/youtu\.be\/([^?&#]+)/i) ?? trimmed.match(/youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)([^?&#]+)/i) ?? trimmed.match(/[?&]v=([^?&#]+)/i);

  if (ytMatch && ytMatch[1]) {
    return {
      type: "youtube",
      id: ytMatch[1],
      src: `https://www.youtube.com/embed/${ytMatch[1]}`,
    };
  }

  return { type: null };
};

// 콘텐츠 상세 GET
const getOrderContentDetail = async () => {
  try {
    const res = await axios.get("/new_api/customer/order/content/one/" + orderContentId);
    myContents.value = res.data.data;
  } catch (error) {
    console.error(error);
  }
};

// 콘텐츠 개별 다운로드
const downloadContent = async (orderDownloadId) => {
  try {
    const res = await axios.get(`/new_api/customer/order/content/download/one?orderContentId=${orderContentId}&orderDownloadId=${orderDownloadId}`, {
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    const downloadLink = Object.assign(document.createElement("a"), {
      href: url,
      download: decodeURIComponent(
        res.headers["content-disposition"]
          .match(/filename\*?=(UTF-8[''].*'')?([^;]+)/)[2]
          .trim()
          .replace(/^"=\?UTF-8\?Q\?/, "")
          .replace(/\?="$/, ""),
      ),
    });

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  }
};

// 콘텐츠 일괄 다운로드 (ZIP)
const downloadZIPContent = async () => {
  try {
    const res = await axios.get(`/new_api/customer/order/content/download/zip?orderContentId=${orderContentId}`, {
      responseType: "blob",
    });

    const blob = new Blob([res.data], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);

    const downloadLink = Object.assign(document.createElement("a"), {
      href: url,
      download: decodeURIComponent(
        res.headers["content-disposition"]
          .match(/filename\*?=(UTF-8[''].*'')?([^;]+)/)[2]
          .trim()
          .replace(/^"=\?UTF-8\?Q\?/, "")
          .replace(/\?="$/, ""),
      ),
    });

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  }
};

// 다운로드 기한 만료 체크
const today = new Date();
const base = new Date("2000-01-01");

const isExpired = (date) => {
  const expirationDate = new Date(date);
  return expirationDate < today;
};

const formDownloadDate = (d) => {
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };
  const date = new Date(d);
  return date.toLocaleDateString("ko-KR", options).replace(/(\d+)\D(\d+)\D(\d+)\D(\d+)\D(\d+)/, "$1.$2.$3 $4:$5:$6");
};
</script>

<style scoped lang="scss">
/* ========================================
   Variables & Reset
   ======================================== */
.mypage-redesign {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 0;
  font-family: "Pretendard", "Malgun Gothic", sans-serif;
}

/* ========================================
   Main Container
   ======================================== */
.mypage-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  display: grid;
  grid-template-columns: 230px 1fr;
  gap: 40px;

  @media (max-width: 1023px) {
    grid-template-columns: 240px 1fr;
    gap: 32px;
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    padding: 20px 16px 40px;
  }
}

/* ========================================
   Main Content
   ======================================== */
.main-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* ========================================
   Content Detail Section
   ======================================== */
.content-detail-section {
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 767px) {
    padding: 24px 16px;
  }
}

/* ========================================
   Content Hero
   ======================================== */
.content-hero {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding-bottom: 32px;
  border-bottom: 1px solid #dee0e3;

  @media (max-width: 767px) {
    flex-direction: column;
    padding-bottom: 24px;
  }
}

.content-thumbnail {
  width: 160px;
  aspect-ratio: 16 / 9;
  flex-shrink: 0;
  background: #f5f5f5;
  border-radius: 12px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
}

.content-header {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.content-title {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 767px) {
    font-size: 18px;
  }
}

.content-expiration {
  font-size: 14px;
  color: #555961;

  .expiration-unlimited {
    color: #0c3388;
    font-weight: 600;
  }

  .expiration-label {
    margin: 0 0 4px 0;
    font-weight: 500;
  }

  .expiration-date {
    margin: 0;
  }

  .expired-badge {
    display: inline-block;
    margin-left: 8px;
    padding: 2px 8px;
    background: #e11d48;
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
  }

  &.expired {
    color: #e11d48;

    .expiration-label,
    .expiration-date {
      color: #e11d48;
    }
  }
}

/* ========================================
   Content Actions Section
   ======================================== */
.content-actions-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #222;
  margin: 0;
}

/* ========================================
   Download Section
   ======================================== */
.download-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.download-all-button {
  align-self: flex-end;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f9fafb;
    border-color: #0c3388;
    color: #0c3388;

    svg {
      stroke: #0c3388;
    }
  }

  svg {
    stroke: #222;
    transition: stroke 0.2s;
  }

  @media (max-width: 767px) {
    width: 100%;
    justify-content: center;
  }
}

.download-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.download-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #dee0e3;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f9fafb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    .download-name {
      color: #0c3388;
    }

    svg {
      stroke: #0c3388;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
  }
}

.download-number {
  font-size: 14px;
  color: #555961;
  font-weight: 500;
}

.download-name {
  font-size: 14px;
  color: #2563eb;
  text-decoration: underline;
  transition: color 0.2s;
}

/* ========================================
   Video Section
   ======================================== */
.video-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.video-item {
  padding: 20px;
  background: #f9fafb;
  border: 1px solid #dee0e3;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.video-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0;
}

.video-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    flex-direction: column;
  }
}

.video-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &.primary {
    background: #0c3388;
    color: #ffffff;

    &:hover {
      background: #092968;
    }
  }

  &.secondary {
    background: #ffffff;
    color: #0c3388;
    border: 1px solid #0c3388;

    &:hover {
      background: #f7f7f8;
    }
  }

  &.disabled {
    background: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #0c3388;
    outline-offset: 2px;
  }
}

/* ========================================
   Unavailable Section
   ======================================== */
.unavailable-section {
  padding: 60px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #9ca3af;
    margin: 0;
  }
}

/* ========================================
   Usage Guide Section
   ======================================== */
.usage-guide-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.usage-guide-content {
  padding: 24px;
  background: #f9fafb;
  border: 1px solid #dee0e3;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 767px) {
    padding: 16px;
  }
}

.guide-block {
  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #222;
    margin: 0 0 12px 0;
  }

  p {
    font-size: 14px;
    color: #555961;
    line-height: 1.6;
    margin: 0 0 8px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* ========================================
   Back Button
   ======================================== */
.back-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 28px;
  background: #0c3388;
  color: #ffffff;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  margin: 16px auto 0;

  &:hover {
    background: #092968;
  }

  &:focus-visible {
    outline: 2px solid #0c3388;
    outline-offset: 2px;
  }
}

/* ========================================
   Focus Styles
   ======================================== */
*:focus-visible {
  outline: 2px solid #0c3388;
  outline-offset: 2px;
}
</style>
